import React from "react";
import {
  Create,
  PasswordInput,
  TextInput,
  SelectInput,
  Toolbar,
  FormWithRedirect,
  regex,
  email,
  minLength,
  maxLength,
} from "react-admin";
//import { BooleanInput,BooleanField} from 'react-admin';
import { Card, CardContent } from "@material-ui/core";
import { RadioButtonGroupInput } from "react-admin";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import RichTextInput from "ra-input-rich-text";
// import validatePasswords from './validatePasswords'
// import { withStyles } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";

// const validatePostalCode = regex(/^\d{6}$/, 'Must be a valid Zip Code');
const validate = [regex(/(^[a-zA-Z ]+$)/, "Must be only Character")];
const validatePhoneNo = regex(/^\d{10}$/, "Must be a valid Phone Number");
const validateEmail = email();
const validatePassword = regex(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
  "Must be a valid password"
);
const validateDescription = [minLength(2), maxLength(250)];

const useStyles = makeStyles((theme) => ({
  controls: {
    // display: 'flex',
    // alignItems: 'center',
    paddingLeft: theme.spacing(4),
    paddingBottom: theme.spacing(1),
  },
}));

export const UserCreate = ({ ...props }) => {
 
  const classes = useStyles();
  return (
    <Create {...props} title={"User"}>
      <FormWithRedirect
        {...props}
        redirect="list"
        render={(formProps) => (
          <div>
            <Card>
              <form>
                <CardContent className={classes.controls}>
                  <Typography variant="h5" gutterBottom>
                    Client Details
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <TextInput
                        label="First Name"
                        source="firstName"
                        style={{ width: "20.5em" }}
                        variant="standard"
                        validate={validate}
                      />
                    </Grid>

                    <Grid item xs={5}>
                      <TextInput
                        label="Last Name"
                        source="lastName"
                        style={{ width: "20.5em" }}
                        variant="standard"
                        validate={validate}
                      />
                    </Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={4}>
                      <Grid item xs={6}>
                        <TextInput
                          label="User Name"
                          source="username"
                          style={{ width: "20.5em" }}
                          variant="standard"
                          validate={validate}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={4}>
                      <Grid item xs={6}>
                        <PasswordInput
                          source="password"
                          validate={validatePassword}
                          variant="standard"
                          style={{ width: "20.5em" }}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={4}>
                      <TextInput
                        label="Email"
                        source="email"
                        validate={validateEmail}
                        variant="standard"
                        style={{ width: "20.5em" }}
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={4}>
                      {/* <SelectInput source="gender" label="Gender" choices={[
                          { id: 'Male', name: 'Male' },
                          { id: 'Female', name: 'Female' },
                          ]}  style={{ width: "20.5em" }}/> */}

                      <TextInput
                        label="Contact Number"
                        source="mobileNo"
                        validate={validatePhoneNo}
                        variant="standard"
                        style={{ width: "20.5em" }}
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={4}>
                      <RadioButtonGroupInput
                        source="gender"
                        choices={[
                          { id: "male", name: "Male" },
                          { id: "female", name: "Female" },
                        ]}
                        variant="standard"
                      />
                    </Grid>
                  </Grid>
                  <Typography variant="h5" gutterBottom>
                    Address Details
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={5}>
                      <TextInput
                        label="Address 1"
                        source="address"
                        fullWidth
                        multiline
                        style={{ width: "20.5em" }}
                        // validate={required()}
                        // className={classes.width}
                        // formClassName={classes.widthFormGroup}
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={1}></Grid>
                    {/* <Grid item xs={5}>
                       
                      </Grid> */}
                    <Grid item xs={1}></Grid>
                    <Grid item xs={6}>
                      <TextInput
                        label="Country"
                        source="country"
                        style={{ width: "20.5em" }}
                        variant="standard"
                        validate={validate}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextInput
                        label="State"
                        source="state"
                        style={{ width: "20.5em" }}
                        variant="standard"
                        validate={validate}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <TextInput
                        label="City"
                        source="city"
                        style={{ width: "20.5em" }}
                        variant="standard"
                        validate={validate}
                      />
                    </Grid>
                  </Grid>
                  <Typography variant="h5" gutterBottom>
                    Other Information
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={5}>
                      {/* <TextInput label="Language" source="languages"  style={{ width: "20.5em" }} validate={validate}/> */}
                      <SelectInput
                        source="languages"
                        label="Language"
                        choices={[
                          { id: "English", name: "English" },
                          { id: "Hindi", name: "Hindi" },
                          { id: "Marathi", name: "Marathi" },
                        ]}
                        style={{ width: "20.5em" }}
                        variant="standard"
                      />
                      {/* <ReferenceArrayInput source="cert"  reference="Certification">
                                <SelectArrayInput optionText="certificateName" />
                        </ReferenceArrayInput> */}
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={5}>
                      {/* <TextInput label="Certifications" source="certifications"   style={{ width: "20.5em" }} validate={validate}/> */}
                      <SelectInput
                        source="certificateName"
                        label="Certification"
                        choices={[
                          { id: "C", name: "C" },
                          { id: "C++", name: "C++" },
                          { id: "Java", name: "Java" },
                        ]}
                        style={{ width: "20.5em" }}
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={6}>
                      <RichTextInput
                        label="Description"
                        source="description"
                        validate={validateDescription}
                        variant="standard"
                        style={{ width: "20.5em" }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <Toolbar
                  record={formProps.record}
                  basePath={formProps.basePath}
                  undoable={true}
                  invalid={formProps.invalid}
                  handleSubmit={formProps.handleSubmit}
                  saving={formProps.saving}
                  resource="User"
                  redirect="list"
                />
              </form>
            </Card>
          </div>
        )}
      />
    </Create>
  );
};

// export const UserCreate = ({ classes, ...props }) => {
//    return (
//         <Create title='User ' {...props}
//     //   {...props}
//         >
//         {/* <SimpleForm label="User Info"  toolbar={<PostEditToolbar />}> */}
//         {/* <FormTab label="User Details"> */}
//         <FormWithRedirect
//             {...props}
//             render={(formProps) => (

//                 <Card>
//                     <form>
//                         <CardContent>
//                         <Grid container spacing={1}>

//                            <Grid item xs={6} >
//                              <TextInput label="First Name" source="firstName" style={{ width: "14em" }} />
//                            </Grid>
//                            <Grid item xs={6} >
//                              <TextInput label="Last Name" source="lastName" style={{ width: "14em" }} />
//                            </Grid>
//                              <Grid item xs={6}>
//                               <TextInput label="User Name" source="username" />
//                              </Grid>

//                              {/* <Grid item xs={6}>
//                                   <TextInput label="Gender" source="gender"/>
//                                  </Grid> */}
//                              <Grid item xs={6}>
//                             <SelectInput source="gender" label="Gender" style={{ width: "14em" }} choices={[
//                             { id: 'Male', name: 'Male' },
//                             { id: 'Female', name: 'Female' },
//                             ]} />
//                             </Grid>
//                             <Grid item xs={6}>
//                             <TextInput label="Email" source="email" validate={validateEmail}/>
//                             </Grid>
//                             <Grid item xs={6}>
//                             <TextInput label="Contact Number" source="mobileNo" validate={validatePhoneNo}/>
//                           </Grid>
//                             <Grid item xs={6}>
//                             <TextInput label="Country" source="country" />
//                             </Grid>
//                             <Grid item xs={6}>
//                             <TextInput label="State" source="state" />
//                             </Grid>
//                             <Grid item xs={6}>
//                             <TextInput label="City" source="city" />
//                             </Grid>
//                             <Grid item xs={6}>
//                             <PasswordInput source="password" validate={validatePassword} style={{ width: "14em" }}/>
//                             </Grid>
//                             {/* <Grid item xs={6}>
//                             <PasswordInput source="confirmPassword" validate={validatePassword} />
//                             </Grid>               */}
//                             <Grid item xs={6}>
//                             <TextInput label="Language" source="languages" />
//                              </Grid>
//                              <Grid item xs={6}>
//                              <TextInput label="Description" source="description" validate={validateDescription}/>
//                                  </Grid>
//                              <Grid item xs={6}>
//                              <TextInput label="Certifications" source="certifications" />
//                                </Grid>
//                                </Grid>
//                         </CardContent>

//                         <Toolbar
//                       record={formProps.record}
//                       basePath={formProps.basePath}
//                       undoable={true}
//                       invalid={formProps.invalid}
//                       handleSubmit={formProps.handleSubmit}
//                       saving={formProps.saving}
//                       resource="User"
//                     />
//                     </form>
//                 </Card>
//                 // </div>
//             )}
//         />
//         {/* </FormTab> */}
//         {/* </SimpleForm> */}
//         </Create>
// )
// }
export default UserCreate;
